import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Balance, Text } from "@sundae/ui-toolkit";
import { getAssetName } from "../../utils/assets.utils.js";
const BalanceWithAssetName = ({ asset, showSymbol, size, variant, weight, ...balanceProps }) => {
    return (_jsxs(Text, { className: "inline-flex items-center gap-[2px]", size: size, tag: "span", children: [_jsx(Balance, { ...balanceProps, showSymbol: showSymbol, size: size, variant: variant, weight: weight }), !showSymbol && (_jsx(Text, { size: size, tag: "span", variant: variant, weight: weight, children: getAssetName(asset) }))] }));
};
export default BalanceWithAssetName;
//# sourceMappingURL=BalanceWithAssetName.js.map